<template>
    <div class="stu-report-refactor scroll-container">
        <div class="scroll-page">
            <div class="top flex-align">
                <img src="@/assets/report/redLogo.png" alt="" class="logo" />
            </div>
            <div class="report-time">
                <div class="download flex-align">
                    <!-- <i class="el-icon-download" > 生成个人报告</i>
          <span > 报告生成中 <i class="el-icon-loading"></i></span>
          <i class="el-icon-download" > 下载个人报告</i> -->
                </div>
                <div class="ReportGenerationTime">
                    <!-- <span>学期：</span>
                    <span>报告时间：</span> -->
                </div>
            </div>
            <h4 class="title">{{ $route.query.user_name }}同学的作品集</h4>
            <div class="main-wrapper">
                <div class="main" v-if="CollectionOfWorks.length > 0">
                    <div class="grid-container">
                        <!-- 示例项目，你可以替换为实际内容 -->
                        <div class="grid-item" v-for="(item, index) in CollectionOfWorks" :key="index">
                            <div class="ImageDisplay flex-align-center" @click="ViewTheTestPaper(index)">
                                <img class="Thumbnail" :src="item.examPages[0]" alt="">
                                <el-image ref="imageRef" :src="item.examPages[0]" style="display: none;"
                                    :preview-src-list="item.examPages">
                                </el-image>
                                <span class="PageNumber">（共{{ item.examPages.length }}页）</span>
                            </div>
                            <p class="text">{{ item.name }}</p>
                            <p class="text">{{ item.grade }}年级{{ item.classNum }}</p>
                            <p class="text">{{ item.createAt }}</p>
                            <div class="btn" @click="handleImageClick(item)">查看报告</div>
                        </div>
                    </div>
                </div>
                <div class="main flex-align-center" v-else>
                    <span class="NoDataAvailable">暂无数据</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import axios from 'axios';
export default {
    components: {

    },
    computed: {

    },
    data() {
        return {
            CollectionOfWorks: [],
            TermList: [],
        };
    },
    methods: {
        // 个人作品合集
        async getQueryUserWork() {
            let data = {
                userId: this.$route.query.userId,
            }
            try {
                let resData = await this.$Api.Report.getQueryUserWork(data);
                // console.log('个人作品合集', resData);
                if (resData.reportList && Array.isArray(resData.reportList)) {
                    resData.reportList = resData.reportList.map(item => {
                        if (item.examPage0 !== undefined || item.examPage1 !== undefined) {
                            return {
                                ...item,
                                examPages: [item.examPage0, item.examPage1].filter(page => page !== undefined),
                                // examPages2:[]
                            };
                        }
                        return item;
                    });
                }
                this.CollectionOfWorks = resData.reportList || [];
            } catch (error) {
                console.error('获取个人作品合集出错:', error);
            }
        },
        ViewTheTestPaper(index) {
            this.$nextTick(() => {
                this.$refs.imageRef[index].clickHandler();
            });
        },
        async getTermList() {
            this.$Api.DataScreen.queryTermList().then(async res => {
                this.TermList = res.data;
            }).catch(err => { });
        },
        handleImageClick(data) {
            const matchedTerm = this.TermList.find(item => item.key == data.termKey);
            let termName = '';
            if (matchedTerm !== undefined) {
                termName = matchedTerm.termName;
            }
            // PersonalReports?userId=570772&termKey=20251&termKeyName=2025-2026上学期&reportValue=101&monthValue=&term_type=2&classID=193108&name=廖天成
            const routeUrl = this.$router.resolve({
                path: '/PersonalReports',
                query: {
                    userId: this.$route.query.userId,
                    termKey: data.termKey,
                    termKeyName: termName,
                    reportValue: data.reportValue,
                    monthValue: data.testId,
                    term_type: '2',
                    classID: data.classId,
                    name: this.$route.query.user_name
                }
            });
            window.open(routeUrl.href, '_blank')
        },
    },
    mounted() {
        this.getQueryUserWork();
        this.getTermList();
    },
};
</script>
<style lang="less" scoped>
// @import url('./less/new_report_stu_zhushou.less');
.Graphics_dialog {
    width: 100%;
    height: 700px;
    // border: 1px solid #000;
}

.stu-report-refactor {
    background-color: #f4f7f9;

    &.scroll-container {
        min-height: 100vh;
        overflow-y: scroll;
        scroll-snap-type: y mandatory;
    }

    .scroll-page {
        min-height: 100vh;
        scroll-snap-align: start;
    }

    .top {
        width: 100%;
        height: 60px;
        background: linear-gradient(-90deg, #00b384, #01b791);

        .logo {
            width: 126px;
            margin-left: 203px;
        }
    }

    .report-time {
        height: 50px;
        line-height: 50px;
        padding: 0 100px;
        background-color: #fff;
        text-align: right;
        color: #c2c2c2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;

        .download {
            cursor: pointer;

            img {
                width: 21px;
                margin-right: 11px;
            }

            font-size: 15px;
            color: #999;
        }

        .ReportGenerationTime {
            &>span {
                display: inline-block;

                &:last-child {
                    margin-left: 35px;
                }
            }
        }

    }

    .title {
        text-align: center;
        font-weight: bold;
        font-size: 30px;
        color: #00b589;
        line-height: 81px;
        margin: 30px 0;
    }

    .main-wrapper {
        padding: 0 203px;
        height: 80%;
        overflow: hidden;

    }

    .main {
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        // padding: 64px 55px;
        padding: 64px 80px;
        box-sizing: border-box;
        min-height: 800px;
        margin-bottom: 30px;
        .NoDataAvailable {
            font-size: 16px;
            color: #818181;
        }
        .grid-container {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 80px;
        }

        .grid-item {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 20px;
            // text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .ImageDisplay {
                width: 100%;
                border: 1px solid #ddd;
                border-radius: 8px;
                // overflow: hidden;
                margin-bottom: 10px;
                position: relative;

                .Thumbnail {
                    width: 280px;
                    height: auto;
                    // border: 1px solid #000;
                }

                //  height: 150px;
                .el-image {
                    // height: 300px;
                    width: 280px;
                    height: auto;
                }

                .PageNumber {
                    position: absolute;
                    bottom: 10px;
                    // right: 10px;
                    font-size: 16px;
                    color: #818181;
                    // margin: 0 auto;
                    left: 38%;
                    font-weight: bold;
                }
            }

            .text {
                font-size: 16px;
                line-height: 25px;
                color: #818181;
            }

            .btn {
                // height: 30px;
                margin: 0 auto;
                // border: 1px solid #000;
                cursor: default;
                font-size: 18px;
                color: #00b386;
                font-weight: bold;
                margin-top: 15px;
            }
        }
    }
}
</style>